<template>
  <div>
    <div v-if="isMobile">
      <div class="row justify-center q-mt-lg" v-if="loading">
        <SAISpinner />
      </div>
      <div v-else>
        <div class="q-px-md q-pb-sm q-pt-lg q-mt-sm">
          <span class="text-weight-bold">Claim Date</span>
        </div>
        <QSeparator color="grey-4" horizontal />
        <div v-for="(claim, index) in claims" :key="index">
          <div class="q-pa-md">
            <div class="row justify-between q-mb-sm">
              <span class="text-weight-bold">
                {{ claim.claimDate | parseDate('yyyy-MM-dd') }}
              </span>
              <span>#{{ claim.claimId }}</span>
            </div>
            <div class="row justify-between q-mb-sm">
              <p>
                {{
                  $Constants.CLAIM_TYPES[claim.claimType]
                    ? $Constants.CLAIM_TYPES[claim.claimType].label
                    : claim.claimType
                }}
              </p>
              <SAILink
                class="cursor-pointer"
                v-if="claim.fileIds"
                :disable="receiptsOpening[claim.claimId]"
                @click="$emit('open:receipts', claim)"
              >
                <span class="text-weight-medium">View Receipt</span>
                <SAISpinner
                  size="14px"
                  class="q-ml-sm"
                  v-if="receiptsOpening[claim.claimId]"
                />
              </SAILink>
            </div>
            <div class="row justify-between q-mb-sm">
              <p>Amount</p>
              <p class="text-weight-bold">{{ claim.total | currency }}</p>
            </div>
            <div class="row justify-between">
              <p>Status</p>
              <p>
                {{
                  $Constants.CLAIM_STATUSES[claim.statusName]
                    ? $Constants.CLAIM_STATUSES[claim.statusName].label
                    : claim.statusName
                }}
              </p>
            </div>
          </div>
          <QSeparator color="grey-4" horizontal />
        </div>
      </div>
    </div>
    <QTable
      v-else
      flat
      :columns="columns"
      :data="claims"
      :loading="loading"
      table-header-class="text-weight-bold"
      :pagination="{ rowsPerPage: 0 }"
      hide-pagination
    >
      <template v-slot:header-cell="props">
        <QTh :props="props">
          <span class="text-weight-bold">
            {{ props.col.label }}
          </span>
        </QTh>
      </template>
      <template v-slot:body-cell-receipt="props">
        <QTd :props="props">
          <SAILink
            class="cursor-pointer"
            v-if="props.value"
            :disable="receiptsOpening[props.row.claimId]"
            @click="$emit('open:receipts', props.row)"
          >
            <span class="text-weight-medium">View Receipt</span>
            <SAISpinner
              size="14px"
              class="q-ml-sm"
              v-if="receiptsOpening[props.row.claimId]"
            />
          </SAILink>
        </QTd>
      </template>
      <template v-slot:body-cell="props">
        <QTd :props="props">
          <p>{{ props.value }}</p>
        </QTd>
      </template>
    </QTable>
  </div>
</template>

<script>
import { QTable, QTd, QTh, QSeparator } from 'quasar';
import { SAILink, SAISpinner } from 'ecx.saigon.ui.common';
import columns from './columns';

export default {
  name: 'ClaimTable',
  props: {
    isMobile: Boolean,
    loading: Boolean,
    claims: {
      type: Array,
      default: () => []
    },
    receiptsOpening: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      columns
    };
  },
  components: {
    QTable,
    QTd,
    QTh,
    QSeparator,
    SAILink,
    SAISpinner
  }
};
</script>
